import { faNoteSticky } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Dropdown, Form, Table } from "react-bootstrap";
import { ClinkNote, ClinkNotesResponseDto, MessageType, ResponseStatus } from "../../../utils/types";
import dayjs from "../../../utils/dayjs";
import { ClinkNotes } from "../../../services/ClinkNotes";
import Loading from "../../../utils/Loding";
import StateHelper from "../../../utils/StateHelper";

interface CustomButtonStyles {
  backgroundColor: string
}
interface ClinkNotesDropdownProps {
  clinkId: string;
  notes: ClinkNote[]
}

function ClinkNotesDropdown(props:ClinkNotesDropdownProps) {
  const { clinkId } = props;
  const [clinkNotesResponseDto, setClinkNotesResponseDto] = useState<ClinkNotesResponseDto>(null);
  const [newNote, setNewNote] = useState("");
  const [error, setError] = useState("");
  const [dirty, setDirty] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isHover, setIsHover] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open, clinkId]);

  const userListResponseDto = StateHelper.getUserListResponseDto();

  const handleToggle = (toogle:boolean) => {
    if (toogle && (!dirty || error)) {
      setError("");
      ClinkNotes.getClinkNotes(clinkId, setClinkNotesResponseDto);
      setDirty(true);
    }
    setOpen(toogle);
  }
  const handleAddNote = async() => {
    const result:any = await ClinkNotes.addClinkNote(clinkId, newNote);
    if (!result.error) {
      ClinkNotes.getClinkNotes(clinkId, setClinkNotesResponseDto);
      setNewNote("");
      setError("");
      inputRef.current?.focus();
    } else {
      setError(result.error.message ? result.error.message : "Error");
    }
  }

  const handleKeyDown = (e:any) => {
    if (e.key === 'Enter' && newNote) {
      handleAddNote();
    }
  }

  const notesIcon = <FontAwesomeIcon icon={faNoteSticky} fixedWidth></FontAwesomeIcon>;

  let customButtonStyles:CustomButtonStyles = {backgroundColor: "" };
  if (props.notes?.length || clinkNotesResponseDto?.clinkNotes?.length) {
    customButtonStyles.backgroundColor = isHover ? "darkgreen" : "green";
  }

  let clinkNotesElement;
  if (clinkNotesResponseDto && clinkNotesResponseDto.status === ResponseStatus.LOADING) {
    clinkNotesElement = <Loading />
  } else if (clinkNotesResponseDto && clinkNotesResponseDto.clinkNotes) {
    clinkNotesElement = (
      <Table style={{ width: "100%" }}>
        <tbody>
          {
            clinkNotesResponseDto.clinkNotes.map((clinkNote:ClinkNote) => {
              return (
                <tr key={clinkNote.uuid}>
                  <td> - {dayjs.utc(clinkNote.last_update).format('YYYY-MM-DD')}</td>
                  <td >
                    {(() => {
                      const user = userListResponseDto && userListResponseDto.status === ResponseStatus.OK ? userListResponseDto.userListResponse.find((u) => u.email === clinkNote.created_by) : null;
                      if (user) {
                        return user.name;
                      } else {
                        return clinkNote.created_by;
                      }
                    })()}
                  </td>
                  <td style={{ maxWidth: "210px", whiteSpace: "pre-wrap" }}>{clinkNote.message}</td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  return (
    <Dropdown onToggle={handleToggle}>
      <Dropdown.Toggle
        style={{ fontSize: 12, borderRadius: 0, ...customButtonStyles }}
        size="sm"
        variant="primary"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className="dropdown-without-arrow"
      >
        {notesIcon}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "520px" }}>
        <div style={{ margin: "10px", display: "flex" }}>
          <Form.Control
            as="input"
            type="text"
            size="sm"
            onChange={(e) => setNewNote(e.target.value)}
            onKeyDown={handleKeyDown}
            value={newNote}
            ref={inputRef}
          />
          <Button
            variant="primary"
            size="sm"
            style={{ marginLeft: "10px", minWidth: "100px", fontSize: "12px" }}
            disabled={!newNote}
            onClick={handleAddNote}
          >
            Add note
          </Button>
        </div>
        <div style={{ margin: "0 10px", maxHeight: "400px", overflow: "auto" }}>
          {
            error && error.length > 0 ?
              <Alert variant={MessageType.DANGER}>{error}</Alert>
            : clinkNotesElement
          }
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default ClinkNotesDropdown;